// Pure semantic-version helpers for the OTA updater. Kept free of Capacitor/env
// imports so the comparison logic is unit-testable in isolation.

/**
 * True when `candidate` is a strictly higher semantic version than `base`.
 * Missing segments count as 0; equal versions return false.
 */
export function isNewerVersion(candidate: string, base: string): boolean {
  const candidateParts = candidate.split('.').map((part) => Number(part) || 0);
  const baseParts = base.split('.').map((part) => Number(part) || 0);
  for (let i = 0; i < Math.max(candidateParts.length, baseParts.length); i++) {
    const c = candidateParts[i] || 0;
    const b = baseParts[i] || 0;
    if (c > b) return true;
    if (c < b) return false;
  }
  return false;
}

/**
 * Decide whether the manifest bundle should replace what's running. Only apply
 * when the manifest is STRICTLY newer than the running version, so a fresh
 * native binary is never downgraded to an older OTA bundle still advertised in
 * version.json (installing 1.1.0 must not pull a stale 1.0.7 bundle over itself).
 *
 * The shipped bundle reports the sentinel "builtin"; its effective version is
 * the one baked into the native build.
 */
export function shouldApplyBundle(
  currentVersion: string,
  builtinVersion: string,
  manifestVersion: string,
): boolean {
  const effectiveCurrent = currentVersion === 'builtin' ? builtinVersion : currentVersion;
  return isNewerVersion(manifestVersion, effectiveCurrent);
}
